export default __webpack_public_path__ + "static/btn-enroll-0f4f166529d5cf2bf017cc453058a48f.png";